






















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class HeaderBar extends Vue {
  @Prop({ type: String, default: '' })
  title!: string
  fixClass = ''

  mounted() {
    //顶部固定 todo  首页有样式冲突 先不加
    document.addEventListener('scroll', this.onScroll, false)
  }

  destroyed() {
    document.removeEventListener('scroll', this.onScroll)
  }

  onScroll() {
    const top = document.documentElement.scrollTop || document.body.scrollTop
    const routerView = document.querySelector('.router-view')

    const vh =
      document.compatMode == 'CSS1Compat'
        ? document.documentElement.clientHeight
        : (routerView as HTMLElement).offsetHeight // 浏览器视口的高度
    const height = (routerView as HTMLElement).offsetHeight // 文档的总高度
    if (height > vh + 80 && top > 0) {
      this.fixClass = 'fixed'
      document.body.className = 'head-fixed'
    } else {
      this.fixClass = ''
      document.body.className = ''
    }
  }
}
